import { useEffect, useState } from 'react';
import './App.css';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

import SpeakFromInput from './components/SpeakFromInput.js'
import SpeakExistingText from './components/SpeakExistingText.js'

function App() {
  const [ids, setIds] = useState([]);
  const [id, setId] = useState('')
  const [words, setWords] = useState([]);
  const [tab, setTab] = useState(0)

  useEffect(() => {
    fetch('/words_new_final.json')
      .then(response => response.json())
      .then(data => {
        setWords(data)
      })

    fetch('/ids.json')
      .then(response => response.json())
      .then(data => {
        setIds(data)
      })
  }, [])

  return (
    <div className="App">
      <div className="tabs">
        <ul>
          <li className={tab === 0 ? 'is-active' : ''} onClick={() => setTab(0)}><a>Texts</a></li>
        </ul>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={ids.map((id) => ({ id, label: id }))}
          sx={{ width: 300 }}
          onChange={(e, { id }) => setId(id)}
          renderInput={(params) => <TextField {...params} label="Text" />}
        />
      </div>
      { tab === 0 && <SpeakExistingText words={words} textId={id} /> }
    </div>
  );
}

export default App;
